export default __webpack_public_path__ + "static/media/31.0026bfe0.png";